module.exports = __webpack_public_path__ + "img/men.ba5b0cd0.png";